// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2Lrok","radioRow":"SimpleQuestionBuilderModal_radioRow__29Dzr"};